import { readBetUserLedgerList } from '@/api/bet/read';
import { betUserLedgerListColumns } from '@/component/bet/table/BetColumnData';
import Header from '@/component/Header';

import { Tables } from '@/component/pools/table/Tables';
import { packBigNumbers } from '@/lib/BigNumbers';
import { SUCCESS } from '@/lib/common/name-space';
import { betStatusFilter } from '@/lib/filter/bet';
import { ResReadBetUserLedgerListType } from '@/types';
import { Box, Card, CardContent, Divider } from '@mui/material';
import { toast } from 'react-toastify';
import BigNumber from 'bignumber.js';
import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

export default function BetUserLedgerList() {
  const [list, setList] = useState<ResReadBetUserLedgerListType[]>([]);
  const [totalAmount, setTotalAmount] = useState<string>('');
  const {
    state: { address },
  } = useLocation();

  useEffect(() => {
    (async () => {
      const re = await readBetUserLedgerList(address);
      console.log(re);
      if (re.status !== SUCCESS) {
        toast.error(re.message);
        return;
      }

      let total = BigNumber(0);
      const data = re.data.data.map((item: any) => {
        total = total.plus(item.amount);
        return {
          ...item,
          betId: item.bet_id.toString(),
          status: betStatusFilter(item.status),
          amount: packBigNumbers(item.amount),
          regDt: item.reg_dt,
        };
      });

      setList(data);
      setTotalAmount(packBigNumbers(total.toString()) || '0');
    })();
  }, [address]);
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
          height: '100vh',
          maxHeight: '100vh',
        }}
      >
        <Card>
          <Header title={`${address} 베팅 내역`} />
          <Divider />
          <Box mb={2} />
          total BP: {totalAmount}
          <CardContent sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
            {list && <Tables list={list} columns={betUserLedgerListColumns} getRowId={(row) => row.betId} />}
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
